app.controller("CreateQuestionnaireController", ["$scope", "StaticData", "QuestionnairesService", "$stateParams", "$uibModal", "Students", "Users", "$state", "ConfirmModal", "toastr", "usSpinnerService",
    function ($scope, StaticData, QuestionnairesService, $stateParams, $uibModal, Students, Users, $state, ConfirmModal, toastr, usSpinnerService) {
        $scope.panelTitle = 'კითხვარის შექნა';
        $scope.buttonText = 'შენახვა';
        $scope.totalStudents = 0;
        $scope.questionnaire = {
            title: null,
            description: null,
            mandatory: true,
            groups: []
        };

        $scope.range = [
            {'name': 1, 'val': false},
            {'name': 2, 'val': false},
            {'name': 3, 'val': false},
            {'name': 4, 'val': false},
            {'name': 5, 'val': false},
            {'name': 6, 'val': false},
            {'name': 7, 'val': false},
            {'name': 8, 'val': false},
            {'name': 9, 'val': false},
            {'name': 10, 'val': false},
        ];

        if ($stateParams.operationType === 'edit') {
            usSpinnerService.spin("root");
            $scope.panelTitle = 'კითხვარის რედაქტირება';
            QuestionnairesService.getTemplateById($stateParams.questionnaireId).then(function (result) {
                $scope.questionnaire = result;
                // TODO sort questions in groups
                // $scope.questionnaire.questions = _.sortBy($scope.questionnaire.questions, 'order');
                generateRange();
                usSpinnerService.stop("root");
            }, function (err) {
                console.log('--err--', err);
            });
        }

        if ($stateParams.operationType === 'send') {
            $scope.panelTitle = 'კითხვარის გადაგზავნა';
            QuestionnairesService.getById($stateParams.questionnaireId).then(function (result) {
                $scope.questionnaire = result;
                // TODO sort questions in groups
                // $scope.questionnaire.questions = _.sortBy($scope.questionnaire.questions, 'order');
            }, function (err) {
                console.log('--err--', err);
            });
        }

        function addQuestionGeneral(addTo) {
            return $uibModal.open({
                controller: "CreateQuestionWindowController",
                templateUrl: _pb + 'admin/questionnaires/create-question-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            'addTo': addTo
                        };
                    }
                }
            }).result;
        }

        $scope.addGroup = function () {
            $uibModal.open({
                controller: "CreateGroupWindowController",
                templateUrl: _pb + 'admin/questionnaires/create-group-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {

                        };
                    }
                }
            }).result
                .then(function (result) {
                    $scope.questionnaire.groups.push(result);
                }, function (error) {
                    console.log(error)
                });
        };

        $scope.addQuestion = function (group) {
            addQuestionGeneral(group).then(function (result) {
                if (result.type === 'range') {
                    result.tempRange = $scope.range.slice(0, result.range);
                }
                result.order = group.questions.length + 1;
                group.questions.push(result);
                group.questions = _.sortBy(group.questions, 'order');
            });
        };

        $scope.editQuestion = function (group, question) {
            $uibModal.open({
                controller: "CreateQuestionWindowController",
                templateUrl: _pb + 'admin/questionnaires/create-question-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {question: question};
                    }
                }
            }).result
                .then(function () {
                    generateRange();
                    group.questions = _.sortBy(group.questions, 'order');
                }, function (error) {
                });
        };

        let generateRange = function () {
            for(let group in $scope.questionnaire.groups) {
                for (let i in group.questions) {
                    if (group.questions[i].type === 'range') {
                        group.questions[i].tempRange = $scope.range.slice(0, group.questions[i].range);
                    }
                }
            }
        };

        $scope.up = function (group, ord) {
            if (ord === 1) return;

            group.questions[ord - 1].order = ord - 1;
            group.questions[ord - 2].order = ord;
            group.questions = _.sortBy(group.questions, 'order');
        };

        $scope.down = function (group, ord) {
            if (ord === group.questions.length) return;

            group.questions[ord - 1].order = ord + 1;
            group.questions[ord].order = ord;
            group.questions = _.sortBy(group.questions, 'order');
        };

        $scope.deleteQuestion = function (group, question) {
            ConfirmModal.show({
                title: "",
                message: "გსურთ კითხვის წაშლა?"
            }).result.then(function () {
                var index = group.questions.indexOf(question);
                group.questions.splice(index, 1);
                reOrder();
            });
        };

        $scope.copyQuestion = function (group, question) {
            ConfirmModal.show({
                title: "",
                message: "გსურთ კითხვის კოპირება?"
            }).result.then(function () {
                var newQuestion = {
                    description: question.description,
                    mandatory: question.mandatory,
                    maxText: question.maxText,
                    minText: question.minText,
                    options: question.options,
                    order: question.order+1,
                    questionnaire: question.questionnaire,
                    range: question.range,
                    title: question.title,
                    type: question.type
                };

                for(var i in group.questions) {
                    if(group.questions[i].order > question.order){
                        group.questions[i].order+=1
                    }
                }
                group.questions.push(newQuestion);
                group.questions = _.sortBy(group.questions, 'order');
            });
        };

        $scope.save = function () {
            reOrder();

            if ($stateParams.operationType === 'create') {
                QuestionnairesService.addTemplate($scope.questionnaire).then(function () {
                    toastr.success('', 'კითხვარი შენახულია');
                    $state.go('admin.questionnaires.list')
                }, function (err) {
                    console.log('--QuestionnairesService.create err--', err);
                });
            }
            if ($stateParams.operationType === 'edit') {
                QuestionnairesService.edit($scope.questionnaire).then(function () {
                    toastr.success('', 'კითხვარი რედაქტირებულია');
                    $state.go('admin.questionnaires.list')
                }, function (err) {
                    console.log('--QuestionnairesService.edit err--', err);
                });
            }
        };

        const reOrder = function (){
            for   (let i in $scope.questionnaire.groups) {
                $scope.questionnaire.groups[i].questions = $scope.questionnaire.groups[i].questions.map(function (question, index) {
                    question.order = index + 1;
                    return question;
                })
            }
        };
    }
]);
